<template lang="pug" src="./hero.pug"></template>

<script>
export default {
  props: ['props'],
  mounted () {
    setTimeout(() => {
      this.$refs.text.classList += ' hero__text--slide'
    }, 100)
  }
}
</script>



// WEBPACK FOOTER //
// hero.vue?a633ea22